import Title from 'components/Title';
import { useMainContext } from 'context/MainContext';
import { IRule } from 'interfaces/IRule';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRuleService } from 'services/ruleService';
import { Container } from './styles';

const AddEditRule: React.FC = () => {
  const ruleEdit = useLocation().state as IRule;
  const navigate = useNavigate();
  const { setDialog } = useMainContext();
  const [validated, setValidated] = useState(false);
  const { ruleService } = useRuleService();
  const [ruleAddEdit, setRuleAddEdit] = useState<IRule>({
    Description: ''
  } as IRule);

  const handleConfirm = useCallback(async () => {
    try {
      if (ruleEdit?.Id) {
        await ruleService.update(ruleAddEdit);
      } else await ruleService.add(ruleAddEdit);
      navigate(-1);
    } catch (error) {
      console.log(`error in AddRule - function handleConfirm, error:${error}`);
    }
  }, [ruleEdit?.Id, ruleService, ruleAddEdit, navigate]);

  const handleSubmit = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      const form = event.currentTarget;

      event.preventDefault();
      event.stopPropagation();
      setValidated(!form.checkValidity());

      if (form.checkValidity())
        setDialog({ show: true, callBackConfirm: handleConfirm });
    },
    [handleConfirm, setDialog]
  );

  useEffect(() => {
    if (ruleEdit?.Id) {
      setRuleAddEdit(ruleEdit);
    }
  }, [ruleEdit]);
  return (
    <Container>
      <Title backButton> {ruleEdit?.Id ? 'Editar' : 'Adicionar'} Regra </Title>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Form.Group as={Col} xs={12} controlId="validationName">
            <Form.Label>
              <h3>Descrição</h3>
            </Form.Label>
            <Form.Control
              type="text"
              name="description"
              required
              placeholder="Descrição"
              defaultValue={ruleAddEdit?.Description}
              onChange={e =>
                setRuleAddEdit(prevState => ({
                  ...prevState,
                  Description: e.target.value
                }))
              }
            />
            <Form.Control.Feedback type="invalid">
              Campo Obrigatório
            </Form.Control.Feedback>
          </Form.Group>
        </Row>
        <Row>
          <Col xs={12}>
            <Button variant="primary" type="submit">
              Salvar
            </Button>
          </Col>
        </Row>
      </Form>
      <Row />
    </Container>
  );
};

export default AddEditRule;
